import { NewProjectSuccessContainer } from "../../../../container"


const NewProjectSuccessPage = () => {
  
    
  return <NewProjectSuccessContainer/>
}

export default NewProjectSuccessPage